import { useEffect, useState } from "react";
import { differenceInHours } from "date-fns";
import useHilosStore from "./useHilosStore";

const MIGRATION_MODAL_KEY = "migration_modal_last_shown";
const HOURS_UNTIL_NEXT_SHOW = 24;

export const clearMigrationModalTimestamp = () => {
  localStorage.removeItem(MIGRATION_MODAL_KEY);
};

export const useMigrationModal = () => {
  const { session } = useHilosStore();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!session) {
      return;
    }

    const lastShownTimestamp = localStorage.getItem(MIGRATION_MODAL_KEY);
    const now = Date.now();

    if (!lastShownTimestamp) {
      setIsOpen(true);
      localStorage.setItem(MIGRATION_MODAL_KEY, now.toString());
      return;
    }

    const lastShown = parseInt(lastShownTimestamp, 10);
    const hoursSinceLastShown = differenceInHours(now, lastShown);

    if (hoursSinceLastShown >= HOURS_UNTIL_NEXT_SHOW) {
      setIsOpen(true);
      localStorage.setItem(MIGRATION_MODAL_KEY, now.toString());
    }
  }, [session]);

  const handleOpenChange = (open: boolean) => {
    setIsOpen(open);
    if (!open) {
      localStorage.setItem(MIGRATION_MODAL_KEY, Date.now().toString());
    }
  };

  return {
    isOpen,
    handleOpenChange,
  };
};

